import { Checkbox, TableCell } from "@material-ui/core";
import React, { Component } from "react";
import styled from "styled-components";

import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";

const CenteredDiv = styled.div`
  padding-left: 10px;
  text-align: center;
`;

export class SelectGuestsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGuests: []
    };
  }

  toggleGuestSelection = guest => () => {
    const { selectedGuests } = this.state;
    const currentIndex = selectedGuests.indexOf(guest);
    const newSelectedGuests = [...selectedGuests];

    if (currentIndex === -1) {
      newSelectedGuests.push(guest);
    } else {
      newSelectedGuests.splice(currentIndex, 1);
    }

    this.setState({
      selectedGuests: newSelectedGuests
    });
    this.props.onSelectedGuestsChanged(newSelectedGuests);
  };

  guestsTableColumns = [
    {
      id: "guestName",
      label: "Name",
      isString: true,
      isBaseColumn: true,
      searchable: true,
      cellValueCalculator: guest =>
        `${guest.contact.firstName} ${guest.contact.lastName}`
    },
    {
      id: "add",
      label: "Add",
      actions: true,
      cell: ({ data }) => (
        <TableCell>
          <CenteredDiv>
            <Checkbox
              checked={this.state.selectedGuests.indexOf(data) !== -1}
              onClick={this.toggleGuestSelection(data)}
            />
          </CenteredDiv>
        </TableCell>
      )
    }
  ];

  render() {
    return (
      <EnhancedTable
        columnDefinitions={this.guestsTableColumns}
        rows={this.props.guests}
        sortable={false}
        orderBy={this.guestsTableColumns[0]}
        shouldHideConfig
        shouldHideExport
        searchHintText="Search by Guest"
        searchable
        height={this.props.height}
        minHeight={this.props.minHeight}
        maxHeight={this.props.maxHeight}
      />
    );
  }
}

SelectGuestsTable.propTypes = {
  guests: PropTypes.object.isRequired,
  onSelectedGuestsChanged: PropTypes.func.isRequired,
  height: PropTypes.number,
  minHeight: PropTypes.number,
  maxHeight: PropTypes.number
};

SelectGuestsTable.defaultProps = {
  height: undefined,
  minHeight: undefined,
  maxHeight: undefined
};

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(SelectGuestsTable);
